<template lang="pug">
  JobRevisionHeader(title="reference_pictures", :showTitle="false")
</template>

<script>
import JobRevisionHeader from '~/components/JobRevisions/Header'
export default {
  components: { JobRevisionHeader }
}
</script>

